<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات شروط امتیاز دستگاه</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <button type="button" (click)="ReadData_DeviceCondition()" class="btn btn-info" style="margin-left: 5px;"><i
              class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button routerLink="/DeviceConditionForm" type="button" class="btn btn-success" style="margin-left: 5px;"><i
              class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>روز</th>
              <th>تعجیل</th>
              <th>تاخیر</th>
              <th>برابر</th>
              <th>تاریخ</th>
              <th>کاربر</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceCondition
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: DataList_DeviceCondition.length
                      }
            ">
              <td>{{DataList_DeviceCondition.indexOf(item)+1}}</td>
              <td>{{item.day}}</td>
              <td>{{item.tajil}}</td>
              <td>{{item.takhir}}</td>
              <td>{{item.brabar}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>
